// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3lnet","main":"index-main-1WJ5h"};